"use client";

import { WifiOff } from "lucide-react";
import { cn } from "@/lib/utils";

type OfflineStaleBadgeProps = {
    fromCache?: boolean;
    isOffline?: boolean;
    className?: string;
};

/** Shown when offline and using cached data, or when live Convex data is unavailable. */
export function OfflineStaleBadge({
    fromCache,
    isOffline,
    className,
}: OfflineStaleBadgeProps) {
    if (!fromCache && !isOffline) return null;
    const offline =
        isOffline ?? (typeof navigator !== "undefined" && !navigator.onLine);
    if (!offline && !fromCache) return null;

    return (
        <span
            className={cn(
                "inline-flex items-center gap-1 rounded-md border border-border/60 bg-muted/40 px-2 py-0.5 text-[11px] text-muted-foreground",
                className,
            )}
            role="status"
        >
            <WifiOff className="size-3" aria-hidden />
            {offline ? "Offline · cached data" : "Cached data"}
        </span>
    );
}
